import { ReactNode } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { ButtonConfig } from "../shared/components/HeaderButtons";
import AdminLayout from "../shared/AdminLayout";
import HeaderSearchInput from "../shared/components/HeaderSearch";
import BaseFilters, { FilterOption } from "../shared/components/BaseFilters";
import BaseFilterChip from "../shared/components/FilterChip";
import { getMainFilterIndustrySpecialistOptions } from "./industry-specialist.constants";
import { getIndustrySpecialistFilters } from "./services/industry-specialist-service";
import { usAdminAppRoutes } from "../../../route-definitions";

interface Props {
  children: ReactNode;
  searchInput: string;
  onSearchInputChange: (value: string) => void;
  onFilterChange: (
    mainFilter: FilterOption | null,
    subcategory: FilterOption | null
  ) => void;
  appliedFilters: Record<string, string>;
  onRemoveFilter: (filterKey: string) => void;
}

function IndustrySpecialistsPageLayout({
  children,
  searchInput,
  onSearchInputChange,
  onFilterChange,
  appliedFilters,
  onRemoveFilter,
}: Props) {
  const intl = useIntl();
  const history = useHistory();

  function handleButtonClick() {
    history.push(usAdminAppRoutes.createIndustrySpecialist);
  }

  const headerButtons: ButtonConfig[] = [
    {
      id: "add-industry-specialist-button",
      text: intl.formatMessage({ id: "usAdmin.addIndustrySpecialist" }),
      backgroundColor: "green",
      handleClick: handleButtonClick,
      className: "",
    },
  ];

  const mainFilterOptions = getMainFilterIndustrySpecialistOptions(intl);

  return (
    <AdminLayout
      header={<FormattedMessage id="usAdmin.industrySpecialist" />}
      headerButtons={headerButtons}
      headerActions={
        <div className="usadmin-admin-layout">
          <div className="usadmin-header-actions">
            <HeaderSearchInput
              searchInput={searchInput}
              onSearchInputChange={onSearchInputChange}
              placeholder={intl.formatMessage({
                id: "usAdmin.searchByAllFields",
              })}
            />
            <BaseFilters
              onFilterChange={onFilterChange}
              onRemoveFilter={onRemoveFilter}
              mainFilterOptions={mainFilterOptions}
              fetchOptions={getIndustrySpecialistFilters}
              filterLabel={intl.formatMessage({ id: "usAdmin.filter" })}
              selectCategoryPlaceholder={intl.formatMessage({
                id: "usAdmin.selectCategory",
              })}
            />
          </div>
          <BaseFilterChip
            appliedFilters={appliedFilters}
            onRemoveFilter={onRemoveFilter}
            mainFilterOptions={mainFilterOptions}
          />
        </div>
      }
      containerClassName="usadmin-entities-main-container"
    >
      {children}
    </AdminLayout>
  );
}

export default IndustrySpecialistsPageLayout;
